import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { Box, Button } from '@mui/material';

const FormButtonRow: FC = () => {
  const { t } = useTranslation('survey');
  const history = useHistory();
  return (
    <Box sx={{ display: 'flex', gap: 2 }}>
      <Button
        fullWidth
        onClick={() => history.goBack()}
        variant="cta"
        color="secondary"
      >
        {t('settings.cancel')}
      </Button>
      <Button fullWidth type="submit">
        {t('settings.save')}
      </Button>
    </Box>
  );
};

export default FormButtonRow;
